export default function WarningIcon(props) {
  return (
    <svg
      width="31"
      height="30"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.2" cx="15.5" cy="15" r="15" fill="#D53943" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.5293 6C16.3577 6 17.0293 6.67157 17.0293 7.5V16.2273C17.0293 17.0557 16.3577 17.7273 15.5293 17.7273C14.7009 17.7273 14.0293 17.0557 14.0293 16.2273V7.5C14.0293 6.67157 14.7009 6 15.5293 6Z"
        fill="#D53943"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.5293 21.0303C16.3577 21.0303 17.0293 21.7018 17.0293 22.5303L17.0293 22.5C17.0293 23.3284 16.3577 24 15.5293 24C14.7009 24 14.0293 23.3284 14.0293 22.5L14.0293 22.5303C14.0293 21.7018 14.7009 21.0303 15.5293 21.0303Z"
        fill="#D53943"
      />
    </svg>
  );
}
